"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Version", {
  enumerable: true,
  get: function get() {
    return _Version.Version;
  }
});

var _Version = require("./Version.connect");